import { API_URL } from '@/utils/app-constants'

export function resolveMediaUrl(value?: string | null): string | undefined {
  if (!value) return undefined
  if (value.startsWith('blob:') || value.startsWith('data:')) return value
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  if (value.startsWith('/')) return `${API_URL}${value}`
  return value
}
